import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Importa los componentes específicos para las rutas de administración
import AdminHome from '../../../js/Pages/Admin/AdminHome';
import Agenda from '../../../js/Pages/Admin/Agenda';
import Pacientes from '../../../js/Pages/Admin/Pacientes';
//import UserManagement from './UserManagement';
//import Reports from './Reports';

const AdminPanel: React.FC = () => {
  return (
    <div>
      <Routes>
      <Route path="/" element={<AdminHome />} />
      <Route path="/Agenda" element={<Agenda />} />
      <Route path="/Pacientes" element={<Pacientes />} />
        {/* <Route path="users" element={<UserManagement />} />
        <Route path="reports" element={<Reports />} />*/}
        {/* Añade aquí más rutas de administración según sea necesario */}
      </Routes>
    </div>
  );
};



export default AdminPanel;